// FILE: options.js

import axios from 'axios';
import { xorDecrypt } from '../encrypt';
import { BASE_API_URL } from "../constants";

const getToken = () => {
  const encryptedToken = localStorage.getItem("ABAtoken");
  //console.log (xorDecrypt(encryptedToken));
  return xorDecrypt(encryptedToken); // Decrypt the token
};

export const fetchAbaPrinciples = async () => {
  const response = await axios.post(`${BASE_API_URL}/aba-principles/getall`, {}, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
  });
  return response.data;
};

export const fetchPtGoals = async () => {
  const response = await axios.post(`${BASE_API_URL}/pt-goals/getall`, {}, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
  });
  return response.data;
};

export const fetchPatientResponse = async () => {
  const response = await axios.post(`${BASE_API_URL}/patientresponse/getall`, {}, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
  });
  return response.data;
};

export const fetchPtSessionPlans = async () => {
  const response = await axios.post(`${BASE_API_URL}/pt-session-plans/getall`, {}, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
  });
  return response.data;
};

export const fetchPtProgress = async () => {
  const response = await axios.post(`${BASE_API_URL}/pt-progress/getall`, {}, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
  });
  return response.data;
};

export const dropdownOptions97156 = {
  participants: [
    {
      value: "Participant 1",
      Definition: "Description 1",
      example: "Example 1",
    },
    {
      value: "Participant 2",
      Definition: "Description 2",
      example: "Example 2",
    },
    // Add more participants as needed
  ],
  placeOfServiceCode: [
    { value: "Service 1", Definition: "Description 1", example: "Example 1" },
    { value: "Service 2", Definition: "Description 2", example: "Example 2" },
    // Add more places of service as needed
  ],
  bcbaActivitiesPerformed: [
    { value: "Modeling and Demonstration" },
    { value: "Hands-On Practice with Feedback" },
    { value: "Education on ABA Principles" },
    { value: "Goal Setting and Prioritization" },
    { value: "Addressing Concerns/Questions" },
    { value: "Teaching Behavior Management Techniques" },
    { value: "Encouraging Consistency and Generalization" },
    { value: "Monitoring Progress and Adjusting the Plan" },
    { value: "Providing Resources and Support" },
    { value: "Problem-Solving and Troubleshooting Technique" },
    { value: "Implementation of Skill-Building Activities" },
    { value: "Data Collection Training" },
    { value: "Others" },
    // Add more activities as needed
  ],
  bcbaStrategiesApplied: [
    {
      value: "Positive Reinforcement",
      Definition:
        "Providing a preferred item, activity, or praise after a desired behavior, increasing the likelihood that the behavior will occur again.",
      Example:
        "Praising a child or giving a sticker when they complete a task.",
    },
    {
      value: "Negative Reinforcement",
      Definition:
        "Removing an aversive stimulus following a desired behavior, which increases the likelihood of that behavior occurring again.",
      Example:
        "Allowing a child to take a break after they request it appropriately instead of engaging in problem behavior.",
    },
    {
      value: "Antecedent-Behavior-Consequence (ABC) Model",
      Definition:
        "Understanding the sequence of events surrounding a behavior: the antecedent (trigger), the behavior itself, and the consequence (outcome).",
      Example:
        "Teaching caregivers to observe what happens before a tantrum (e.g., being denied a toy) and the consequence that follows (e.g., the child is comforted).",
    },
    {
      value: "Functional Communication Training (FCT)",
      Definition:
        "Teaching alternative ways for a child to communicate their needs, reducing challenging behaviors.",
      Example:
        "Instead of crying for attention, the child is taught to say 'help' or use a picture card.",
    },
    {
      value: "Differential Reinforcement",
      Definition:
        "Reinforcing desired behaviors while withholding reinforcement for undesired behaviors.",
      "DRI (Differential Reinforcement of Incompatible Behavior)": {
        Definition:
          "Reinforcing a behavior that cannot occur simultaneously with the problem behavior (e.g., sitting quietly instead of running).",
      },
      "DRA (Differential Reinforcement of Alternative Behavior)": {
        Definition:
          "Reinforcing an alternative, appropriate behavior (e.g., asking for a break instead of screaming).",
      },
    },
    {
      value: "Prompting and Prompt Fading",
      Definition:
        "Providing cues or assistance to encourage the child to perform a desired behavior, then gradually reducing the assistance over time.",
      Example:
        "Using a hand-over-hand prompt to help a child complete a puzzle, then slowly decreasing physical assistance.",
    },
    {
      value: "Shaping",
      Definition:
        "Reinforcing successive approximations of a behavior to help the child gradually learn a more complex skill.",
      Example:
        "Praising the child first for saying 'buh' when teaching the word 'ball,' and gradually requiring more accurate pronunciation.",
    },
    {
      value: "Task Analysis and Chaining",
      Definition:
        "Breaking a complex task into smaller, manageable steps (task analysis) and teaching the steps in sequence (chaining).",
      "Forward Chaining": {
        Definition: "Teaching the first step first, then moving forward.",
      },
      "Backward Chaining": {
        Definition: "Teaching the last step first, then moving backward.",
      },
      Example:
        "Teaching a child to brush their teeth step by step, starting with taking out the toothbrush.",
    },
    {
      value: "Extinction",
      Definition:
        "Reducing a behavior by no longer providing reinforcement for it.",
      Example:
        "Ignoring a child’s tantrum for attention (if it’s safe to do so), instead of giving in.",
    },
    {
      value: "Token Economy",
      Definition:
        "Using a system of tokens or points that the child can earn for desired behaviors, which can be exchanged for a reward.",
      Example:
        "Giving a child a star sticker each time they follow instructions, which they can later trade for a preferred toy.",
    },
    {
      value: "Generalization and Maintenance",
      Definition:
        "Teaching skills in a way that helps the child apply them in various settings and with different people (generalization) and retain the skills over time (maintenance).",
      Example:
        "Practicing social greetings both at home and at the park to ensure the child can say 'hello' in different contexts.",
    },
    {
      value: "Behavior Contracts",
      Definition:
        "Creating an agreement between the caregiver and child outlining specific behaviors and the rewards for meeting expectations.",
      Example:
        "A simple written agreement stating that if the child completes their homework every day for a week, they will earn a movie night.",
    },
    {
      value: "Visual Supports",
      Definition:
        "Using pictures, charts, or visual schedules to help the child understand expectations and routines.",
      Example:
        "Creating a visual schedule with images to show the steps of the morning routine (e.g., brushing teeth, getting dressed).",
    },
    {
      value: "First-Then Strategy",
      Definition:
        "Using a simple sequence of 'first' (non-preferred task) and 'then' (preferred activity) to motivate the child to complete tasks.",
      Example:
        "'First finish your homework, then you can play with your tablet.'",
    },
    {
      value: "Errorless Learning",
      Definition:
        "Teaching new skills in a way that minimizes the chance of the child making errors, ensuring immediate success and reinforcement.",
      Example:
        "Providing immediate prompts or assistance when teaching a new task, then fading the prompts as the child becomes more proficient.",
    },
    {
      value: "Additional Techniques",
      "Response Cost": {
        Definition:
          "Removing a token or privilege when an undesired behavior occurs.",
        Example: "A child loses a token for calling out in class.",
      },
      "Choice Making": {
        Definition:
          "Offering limited choices to the child to increase engagement and reduce problem behaviors.",
        Example: "'Do you want to read a book or play with blocks?'",
      },
    },
    {
      value: "Other",
    },
  ],

  trainingGoalsAddressed: [
    {
      value: "Understanding ABA Principles",
      Goal: "Help parents understand fundamental ABA concepts such as positive reinforcement, prompting, and behavior analysis.",
      Outcome:
        "Parents can identify and apply basic ABA strategies in everyday situations.",
    },
    {
      value: "Behavior Management",
      Goal: "Equip parents with techniques to manage challenging behaviors (e.g., tantrums, aggression, self-injurious behaviors).",
      Outcome:
        "Parents can implement behavior management strategies consistently, reducing the frequency and intensity of problematic behaviors.",
    },
    {
      value: "Skill-Building and Teaching New Skills",
      Goal: "Teach parents how to help their child develop new skills in areas like communication, social interaction, and daily living tasks.",
      Outcome:
        "Parents are able to use structured teaching methods (e.g., task analysis, chaining) to support skill acquisition.",
    },
    {
      value: "Increasing Communication Skills",
      Goal: "Train parents to support the development of verbal and non-verbal communication, including the use of augmentative and alternative communication (AAC) tools if necessary.",
      Outcome:
        "The child improves in expressing needs and wants, reducing frustration and behavior issues.",
    },
    {
      value: "Promoting Independence",
      Goal: "Teach parents how to encourage independence in daily living activities (e.g., dressing, toileting, eating).",
      Outcome:
        "The child gains more autonomy in self-care tasks, and parents know how to gradually fade assistance.",
    },
    {
      value: "Reducing Problematic Behaviors",
      Goal: "Guide parents in implementing behavior reduction techniques such as extinction, differential reinforcement, and the use of visual supports.",
      Outcome:
        "Parents effectively reduce problematic behaviors while reinforcing positive alternatives.",
    },
    {
      value: "Consistency Across Environments",
      Goal: "Train parents to apply ABA strategies consistently across various settings (e.g., home, school, community).",
      Outcome:
        "The child demonstrates more stable behavior and skill use across different environments.",
    },
    {
      value: "Enhancing Social Skills",
      Goal: "Educate parents on how to support the child in developing social skills, such as sharing, turn-taking, and making eye contact.",
      Outcome:
        "The child becomes more engaged in social interactions and demonstrates improved play and communication skills.",
    },
    {
      value: "Effective Use of Reinforcement",
      Goal: "Teach parents how to use reinforcement effectively to encourage desired behaviors and increase motivation.",
      Outcome:
        "Parents can identify preferred reinforcers and use them strategically, leading to better behavior outcomes.",
    },
    {
      value: "Data Collection and Progress Monitoring",
      Goal: "Train parents on simple methods of data collection (e.g., using tally marks, charts) to track behaviors and monitor progress.",
      Outcome:
        "Parents provide accurate data that helps the BCBA make informed decisions about the child’s treatment plan.",
    },
    {
      value: "Generalization of Skills",
      Goal: "Teach parents strategies to help the child generalize newly learned skills to different people, places, and situations.",
      Outcome:
        "The child applies skills learned in therapy to real-world scenarios, demonstrating greater flexibility.",
    },
    {
      value: "Using Visual Supports and Schedules",
      Goal: "Train parents on how to create and implement visual schedules, token boards, and other visual supports.",
      Outcome:
        "The child has a clearer understanding of expectations and routines, reducing anxiety and confusion.",
    },
    {
      value: "Promoting Positive Parent-Child Interactions",
      Goal: "Enhance the quality of interactions between parents and the child through play, shared activities, and positive communication.",
      Outcome:
        "The parent-child relationship improves, fostering a supportive and engaging learning environment.",
    },
    {
      value: "Addressing Feeding or Mealtime Challenges",
      Goal: "Provide strategies for addressing picky eating, food refusal, or mealtime behavior issues.",
      Outcome:
        "Mealtime becomes more structured and less stressful, and the child expands their range of accepted foods.",
    },
    {
      value: "Preparing for Transitions and Changes",
      Goal: "Teach parents how to prepare the child for transitions (e.g., moving from one activity to another, changing routines).",
      Outcome:
        "The child handles changes and transitions more smoothly, reducing meltdowns or resistance.",
    },
    {
      value: "Increasing Parental Confidence",
      Goal: "Empower parents by building their confidence in using ABA strategies effectively.",
      Outcome:
        "Parents feel more capable and less stressed, leading to better implementation of the treatment plan.",
    },
    {
      value: "Teaching Safety Skills",
      Goal: "Train parents on teaching safety skills such as responding to 'stop,' understanding danger, and following safety rules.",
      Outcome:
        "The child is better equipped to respond to safety cues, and parents can confidently manage safety in various environments.",
    },
    {
      value: "Cultural Sensitivity and Family Values Integration",
      Goal: "Ensure that ABA strategies and goals align with the family’s cultural values, traditions, and preferences.",
      Outcome:
        "The treatment plan feels more personalized and respectful of the family’s lifestyle, leading to better engagement.",
    },
  ],
  parentOrCaregiverResponses: [
    {
      value: "Positive and Engaged Response",
      Description:
        "Parents express enthusiasm and gratitude for the training. They actively participate, ask questions, and show interest in learning new techniques.",
      Example:
        '"This strategy really makes sense! I can see how it will help us at home. Can you show me how to do it again?"',
      "Possible Outcome":
        "High level of engagement and willingness to implement strategies consistently.",
    },
    {
      value: "Confusion or Overwhelm",
      Description:
        "Parents may feel overwhelmed by the information, especially if they are new to ABA therapy. They might struggle to understand specific terms or techniques.",
      Example:
        '"I’m not sure I understand the difference between positive and negative reinforcement. Can you explain it again in simpler terms?"',
      "Possible Outcome":
        "The BCBA may need to slow down, simplify explanations, and provide additional examples or resources.",
    },
    {
      value: "Skepticism or Doubt",
      Description:
        "Parents may be skeptical about the effectiveness of ABA strategies, especially if they have tried other interventions without success.",
      Example:
        '"We’ve tried something like this before, and it didn’t work. How is this different?"',
      "Possible Outcome":
        "The BCBA can address concerns by providing evidence, sharing success stories, and emphasizing the importance of consistency and tailored strategies.",
    },
    {
      value: "Expressing Frustration or Guilt",
      Description:
        "Parents may express frustration or guilt, feeling as though they’ve failed in managing their child’s behavior or that they’re not doing enough.",
      Example:
        '"I feel like I’m doing everything wrong. It’s so hard to keep up with everything."',
      "Possible Outcome":
        "The BCBA can provide reassurance, validate their feelings, and emphasize that progress takes time. Offering small, manageable steps can help reduce overwhelm.",
    },
    {
      value: "Relief and Hopefulness",
      Description:
        "Some parents express relief and hope, especially if they see initial progress or believe that the strategies will provide the support they need.",
      Example:
        '"I’m so relieved to have a plan. This is the first time I feel like we have clear steps to follow."',
      "Possible Outcome":
        "Increased motivation and confidence in implementing the treatment plan.",
    },
    {
      value: "Resistance to Change",
      Description:
        "Parents may be resistant to changing their existing routines or behaviors, especially if they have established habits or beliefs about parenting.",
      Example:
        '"We’ve always handled it this way. I don’t see why we need to change now."',
      "Possible Outcome":
        "The BCBA can use motivational interviewing techniques, explain the benefits of the new strategies, and gradually introduce changes to ease the transition.",
    },
    {
      value: "Concerns About Time and Practicality",
      Description:
        "Parents may worry about the time commitment required to implement ABA strategies, particularly if they have busy schedules or multiple children.",
      Example:
        '"I don’t know if I have time to do all of this every day. It seems like a lot."',
      "Possible Outcome":
        "The BCBA can suggest practical, time-efficient strategies and prioritize the most impactful interventions.",
    },
    {
      value: "Seeking Additional Support or Resources",
      Description:
        "Parents may ask for more resources, such as written guides, videos, or additional training sessions, to help them feel more prepared.",
      Example:
        '"Do you have a handout or video that I can refer to when I’m practicing this at home?"',
      "Possible Outcome":
        "The BCBA can provide supplementary materials, schedule follow-up sessions, or offer ongoing support to help reinforce learning.",
    },
    {
      value: "Emotional Response or Crying",
      Description:
        "Some parents may become emotional during training, especially if they feel overwhelmed, stressed, or touched by the progress their child is making.",
      Example:
        '"It’s just so hard sometimes. I’m trying my best, but it’s exhausting."',
      "Possible Outcome":
        "The BCBA should offer empathy and a supportive listening ear, acknowledging the parent’s feelings and providing encouragement.",
    },
    {
      value: "Expressing a Desire for Quick Fixes",
      Description:
        "Parents may hope for immediate solutions and express impatience if they don’t see quick results.",
      Example:
        '"We’ve been trying this for a week, and nothing has changed yet. Is there something else we can do?"',
      "Possible Outcome":
        "The BCBA can set realistic expectations, explain the importance of consistency, and remind parents that behavior change is a gradual process.",
    },
    {
      value: "Focus on the Child’s Strengths and Improvements",
      Description:
        "Some parents highlight their child’s strengths and express pride in the progress made, focusing on positive aspects.",
      Example:
        '"He’s been making eye contact more often! I’m so happy to see these small changes."',
      "Possible Outcome":
        "This response can boost morale and encourage continued effort from both the parent and the BCBA.",
    },
    {
      value: "Asking for Clarification and Detailed Examples",
      Description:
        "Parents may ask for more examples, role-playing, or clarification to ensure they fully understand the strategies being taught.",
      Example:
        '"Can you show me exactly what I should say when he starts to tantrum?"',
      "Possible Outcome":
        "The BCBA should provide clear, concrete examples and practice scenarios to build the parent’s confidence.",
    },
    {
      value: "Expressing Gratitude",
      Description:
        "Parents may express gratitude for the guidance and support provided by the BCBA, especially if they see positive changes in their child’s behavior.",
      Example:
        '"Thank you so much for your help. We’ve noticed such a difference already!"',
      "Possible Outcome":
        "Positive reinforcement for the BCBA, and it may strengthen the parent-professional relationship.",
    },
    {
      value: "Sharing Observations and Feedback",
      Description:
        "Parents often share their own observations and experiences, providing feedback on what strategies are working or where they are struggling.",
      Example:
        '"The visual schedule really helped yesterday, but he still struggles during transitions."',
      "Possible Outcome":
        "The BCBA can use this feedback to adjust the treatment plan and provide additional strategies.",
    },
    {
      value: "Seeking Reassurance",
      Description:
        "Parents may seek reassurance, wanting to know they are on the right track and making progress.",
      Example:
        '"Is it normal that it’s taking this long? Are we doing everything we should be?"',
      "Possible Outcome":
        "The BCBA can offer encouragement, highlight the progress made, and remind parents that behavior change takes time.",
    },
  ],

  // Add more dropdown data as needed
};
